export default __webpack_public_path__ + "static/media/magic.2d01dd09.svg";